import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['panel', 'backdrop']

  connect() {
    document.addEventListener('keydown', this.handleEsc)
  }

  disconnect() {
    document.removeEventListener('keydown', this.handleEsc)
  }

  open() {
    this.panelTarget.classList.remove('translate-x-full')
    this.panelTarget.classList.add('translate-x-0')
    this.backdropTarget.classList.remove('opacity-0', 'pointer-events-none')
    this.backdropTarget.classList.add('opacity-100')
  }

  close() {
    this.panelTarget.classList.remove('translate-x-0')
    this.panelTarget.classList.add('translate-x-full')
    this.backdropTarget.classList.remove('opacity-100')
    this.backdropTarget.classList.add('opacity-0', 'pointer-events-none')
  }

  handleEsc = (event) => {
    if (event.key === 'Escape') this.close()
  }
}
